module.exports = __webpack_public_path__ + "static/media/chef-dark-gray.02eead91.svg";